import { Injectable, signal, effect } from '@angular/core';

export type Theme = 'light' | 'dark' | 'system';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  readonly current = signal<Theme>(this.loadTheme());

  constructor() {
    effect(() => {
      const theme = this.current();
      try { localStorage.setItem('theme', theme); } catch { /* private browsing */ }
      this.applyTheme(theme);
    });
  }

  set(theme: Theme): void {
    this.current.set(theme);
  }

  private loadTheme(): Theme {
    try {
      return (localStorage.getItem('theme') as Theme) ?? 'system';
    } catch {
      return 'system';
    }
  }

  private applyTheme(theme: Theme): void {
    if (theme === 'system') {
      document.documentElement.removeAttribute('data-theme');
    } else {
      document.documentElement.setAttribute('data-theme', theme);
    }
  }
}
